import { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import FooterBottom from '@bridebook/web/app-shared/components/footer/footer-bottom/footer-bottom';
import FooterContainer from '@bridebook/web/app-shared/components/footer/footer-container/footer-container';
import FooterTop from '@bridebook/web/app-shared/components/footer/footer-top/footer-top';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { ConnectedTypes, IApplicationState } from '@bridebook/web/lib/types';

const storeEnhancer = connect((state: IApplicationState) => ({
  isCordova: state.app.device.isCordova,
}));

interface IProps extends ConnectedTypes<typeof storeEnhancer> {
  hideTop?: boolean;
}

const FooterComponent = ({ isCordova, hideTop, dispatch }: IProps) => {
  const market = useMarket();
  const linkAnalytics = (type: string) => (e: SyntheticEvent<HTMLAnchorElement>) => {
    const url = e.currentTarget.href;
    dispatch({
      type: 'USER_CLICKED_OUTBOUND_LINK_ANALYTICS',
      payload: { url, type },
    });
  };

  return (
    <FooterContainer>
      {!hideTop && (
        <FooterTop isCordova={isCordova} market={market} onAppBadgeClick={linkAnalytics('app')} />
      )}
      <FooterBottom onSocialUrlClick={linkAnalytics('social')} localeSelect={null} />
    </FooterContainer>
  );
};

export default storeEnhancer(FooterComponent);
